// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import { VIBRATE_TYPE } from "../../../../../engines/services/miniGameContent/miniApp";
import { BUNDLE_SMALL_NAME, getOneBundleOnePrefab } from "../../../BundleResourceConfig";
import TouchCardLayerBase from "./TouchCardLayerBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TouchCardDrawBase extends BaseComponent {

	// @property({ type: cc.Node, displayName:'' })
	// nodeTouch: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeTouchArea: cc.Node = null;

    private cardData: number = null;
    // LIFE-CYCLE CALLBACKS:
    private polygon: cc.PolygonCollider[] = [];
    private _parent: TouchCardLayerBase = null;
    private bTouch: boolean = false;

    private touchState = true;

    private oriAreaHeight = 0;
    // onLoad () {}

    start () {
        this.oriAreaHeight = this.nodeTouchArea.height;
        this.initUI();

        // this.initTouchEvent(this.nodeTouch);
    }

    setData(
        cardData: number
        , _parent: TouchCardLayerBase
    ) {
        this.touchState = true;
        if (this.node) {
            cc.Tween.stopAllByTarget(this.node);
        }
        this.nodeTouchArea.stopAllActions();
        if (this.oriAreaHeight != 0) {
            this.nodeTouchArea.height = this.oriAreaHeight;
        }
        this.bTouch = false;
        this._parent = _parent;
        this.cardData = cardData;
        if (this.isInit()) {
            this.initUI();
        }
    }

    initUI() {
        this.polygon = [];
        this.nodeTouchArea.removeAllChildren();

        // let filePath = "prefab/common/touchCardItem/" + this.cardData;
        let self = this;
        let filePath = "prefab/common/touchCardItem/TouchCardItem" + this.cardData;
        getOneBundleOnePrefab(BUNDLE_SMALL_NAME.touchCardBundle, filePath).then(function(prefab){
            let layer = cc.instantiate(prefab);
            self.nodeTouchArea.addChild(layer);
            layer.y = -296.5;
            // layer.y = -self.nodeTouchArea.y;

            let sprContent = layer.getChildByName('sprContent');
            sprContent.active = false;

            self.polygon = layer.getComponents(cc.PolygonCollider);
        });
    }
    
    setTouchState(enable: boolean) {
        this.touchState = enable;
    }

    async endShow() {
        let self = this;
        return new Promise<void> ((resolve)=> {
            if (self.polygon.length <= 0) {
                self.showEffectAni(false);
                resolve();
                return;
            }
            
            self.nodeTouchArea.height = 0;
            let sprContent = self.polygon[0].node.getChildByName('sprContent');
            sprContent.active = true;
            cc.tween(self.nodeTouchArea)
            .to(0.5, {height: self.oriAreaHeight})
            .call(resolve)
            .start();
        });
    }

    isTouch(wPos: cc.Vec2) {
        
        if (!this.touchState) {
            this.showEffectAni(false);
            return;
        }
        
        if (this.polygon.length <= 0) {
            this.showEffectAni(false);
            return;
        }

        for (let o of this.polygon) {
            let nodeItem = o.node;
            let touchPos = nodeItem.convertToNodeSpaceAR(wPos);
            let points = o.points;
            touchPos.x -= o.offset.x;
            touchPos.y -= o.offset.y;
            let isTrigger:boolean = cc.Intersection.pointInPolygon(touchPos, points);
            if (isTrigger) {
                this.showEffectAni(true);
                return;
            }
        }
        this.showEffectAni(false);
    }

    showEffectAni(enable: boolean) {
        this._parent.showEffectAni(enable);
        this.startVibrate(enable);
    }

    startVibrate(enable: boolean) {
        if (enable) {
            if (this.bTouch) {
                return;
            }
            cc.tween(this.node)
            .call(()=> {
                O1HD.getServices().miniGameSrv.getAppApiInstance().vibrate(VIBRATE_TYPE.SHORT);
            })
            .delay(0.05)
            .union()
            .repeatForever()
            .start();
        } else {
            cc.Tween.stopAllByTarget(this.node);
        }
        this.bTouch = enable;
    }


    // update (dt) {}
}
